module.exports = __webpack_public_path__ + "img/bgtop.4b055a1c.jpg";